define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.StockClassDomain = void 0;
    class StockClassDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: StockClassDomain.Heifers, value: "Heifers" },
                    { key: StockClassDomain.Steers, value: "Steers" },
                    { key: StockClassDomain.MixedYoungStock, value: "Mixed Young Stock" },
                    { key: StockClassDomain.Bullocks, value: "Bullocks" },
                    { key: StockClassDomain.Cows, value: "Cows" },
                    { key: StockClassDomain.MixedOlderStock, value: "Mixed Older Stock" },
                    { key: StockClassDomain.CowsAndCalves, value: "Cows And Calves" },
                    { key: StockClassDomain.Ewes, value: "Ewes" },
                    { key: StockClassDomain.Hoggets, value: "Hoggets" },
                    { key: StockClassDomain.Mixed, value: "Mixed" },
                    { key: StockClassDomain.Wethers, value: "Wethers" },
                    { key: StockClassDomain.None, value: "None" },
                    { key: StockClassDomain.Bulls, value: "Bulls" },
                    { key: StockClassDomain.Rams, value: "Rams" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[StockClassDomain.Heifers] = 0;
                this.KeyIndex[StockClassDomain.Steers] = 1;
                this.KeyIndex[StockClassDomain.MixedYoungStock] = 2;
                this.KeyIndex[StockClassDomain.Bullocks] = 3;
                this.KeyIndex[StockClassDomain.Cows] = 4;
                this.KeyIndex[StockClassDomain.MixedOlderStock] = 5;
                this.KeyIndex[StockClassDomain.CowsAndCalves] = 6;
                this.KeyIndex[StockClassDomain.Ewes] = 7;
                this.KeyIndex[StockClassDomain.Hoggets] = 8;
                this.KeyIndex[StockClassDomain.Mixed] = 9;
                this.KeyIndex[StockClassDomain.Wethers] = 10;
                this.KeyIndex[StockClassDomain.None] = 11;
                this.KeyIndex[StockClassDomain.Bulls] = 12;
                this.KeyIndex[StockClassDomain.Rams] = 13;
                this.ValueIndex = {};
                this.ValueIndex["Heifers"] = 0;
                this.ValueIndex["Steers"] = 1;
                this.ValueIndex["Mixed Young Stock"] = 2;
                this.ValueIndex["Bullocks"] = 3;
                this.ValueIndex["Cows"] = 4;
                this.ValueIndex["Mixed Older Stock"] = 5;
                this.ValueIndex["Cows And Calves"] = 6;
                this.ValueIndex["Ewes"] = 7;
                this.ValueIndex["Hoggets"] = 8;
                this.ValueIndex["Mixed"] = 9;
                this.ValueIndex["Wethers"] = 10;
                this.ValueIndex["None"] = 11;
                this.ValueIndex["Bulls"] = 12;
                this.ValueIndex["Rams"] = 13;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.StockClassDomain = StockClassDomain;
    Object.defineProperty(StockClassDomain, "Heifers", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(StockClassDomain, "Steers", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(StockClassDomain, "MixedYoungStock", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(StockClassDomain, "Bullocks", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(StockClassDomain, "Cows", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(StockClassDomain, "MixedOlderStock", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(StockClassDomain, "CowsAndCalves", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(StockClassDomain, "Ewes", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 7
    });
    Object.defineProperty(StockClassDomain, "Hoggets", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 8
    });
    Object.defineProperty(StockClassDomain, "Mixed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 9
    });
    Object.defineProperty(StockClassDomain, "Wethers", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(StockClassDomain, "None", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(StockClassDomain, "Bulls", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 12
    });
    Object.defineProperty(StockClassDomain, "Rams", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 13
    });
    Object.defineProperty(StockClassDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
